import { FC } from 'react';

import { Radio, RadioGroupProps, theme } from 'antd';
import cn from 'classnames';

import { useMedia } from 'shared/hooks';

import styles from './RadioGroup.module.scss';

interface IRadioGroupProps extends RadioGroupProps {
	items: {
		label: string;
		value: string;
		disabled?: boolean;
	}[];
}

export const RadioGroup: FC<IRadioGroupProps> = ({ className, value, items, ...props }) => {
	const {
		token: { colorPrimary, colorBorder },
	} = theme.useToken();
	const isMd = useMedia();

	return (
		<Radio.Group
			{...props}
			className={cn(className, styles.group)}
			style={{ gridTemplateColumns: isMd ? '1fr' : `repeat(${items.length}, 1fr)` }}
			value={value}>
			{items.map((item) => (
				<Radio
					key={item.value}
					className={styles.radio}
					value={item.value}
					disabled={item.disabled}
					style={{ borderColor: value === item.value ? colorPrimary : colorBorder }}>
					{item.label}
				</Radio>
			))}
		</Radio.Group>
	);
};
